module.exports = __webpack_public_path__ + "img/AT0000016076505.c513f799.png";